import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { PhoneNumberFormatPipe } from 'src/app/libs/ui/pipes/phone-number-format/phone-number-format.pipe';
import { ConfirmRemoveDialogComponent } from 'src/app/shared-layout/Components/confirm-remove-dialog/confirm-remove-dialog.component';
import { AccountSettingsService } from 'src/app/shared-layout/header/account-settings/account-setting.service';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { NotificationService } from 'src/app/shared/errors/notification.service';
import { SharedDataService } from 'src/app/shared/services/shared-data.service';
import { ISharedData } from 'src/app/shared/state-management/state-interfaces';
import { CommonService } from 'src/app/shared/utils/common.service';
import { HelperService } from 'src/app/shared/utils/helper.service';
import {
  Utility,
  convertParseDateTime,
  convertDateTimeFormat,
} from 'src/app/shared/utils/utility.service';
import {
  IUser,
  IUserProfile,
  IAccessDetail,
  ICriteria,
} from 'src/app/user-management/user-management-interfaces';
import { UserManagementService } from 'src/app/user-management/user-management.service';
import { UserProfileComponent } from 'src/app/user-management/user-profile/user-profile.component';
const ACTIVE = 'ACTIVE';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-dashboard-user-access-detail',
  templateUrl: './dashboard-user-access-detail.component.html',
  styleUrls: ['./dashboard-user-access-detail.component.scss'],
})
export class DashboardUserAccessDetailComponent implements OnInit, OnDestroy {
  CONSTANTS = CONSTANTS;
  subscription: Subscription | undefined;
  apiSubscription: Subscription | undefined;
  user: IUser | null | undefined;
  sharedDataSubscription?: Subscription;

  activeTab: string = '';
  readonly LANG_CONST = LANG_CONST;
  siteId!: string;
  userId!: string;
  groupTypeId!: string;
  groupName!: string;
  sharedData?: ISharedData;
  profileDetails!: IUserProfile;
  userGroups!: string;
  accessPointCount: number = 0;
  devicesCount: number = 0;
  accessPointCounts!: number;
  allAccess: boolean = false;
  textDescription: string = '';
  lockCount!: number;
  disabledHomeAccess = true;
  disabledOtherAccess = true;
  disabledTemporaryAccess = true;
  userListsubscription: Subscription | undefined;
  getNotExpiredTempRecords!: IAccessDetail[];
  @Input() profileImageSrc: string = 'assets/images/portrait-happy.jpg';
  profileImageLoader: string = CONSTANTS.PROFILE_IMAGE_LOADER;
  @Input() dialogRef?: any; //close event of parent component
  userCredentials: any;
  isUserCardActive: boolean = false;
  commonAccessControl!: boolean;

  constructor(
    private route: ActivatedRoute,
    private userManagementService: UserManagementService,
    private accountSettingService: AccountSettingsService,
    private helperService: HelperService,
    private notificationService: NotificationService,
    private sharedDataService: SharedDataService,
    private router: Router,
    private commonService: CommonService,
    private phoneNumberFormat: PhoneNumberFormatPipe,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.subscription = this.route.params.subscribe((params) => {
      this.userId = Utility.decodeFromBase64(params['id']);
      this.groupTypeId = Utility.decodeFromBase64(params['userGroupId']);
      this.groupName = Utility.decodeFromBase64(params['groupTypeName']);

      this.sharedDataSubscription =
        this.sharedDataService.currentData.subscribe((sharedData) => {
          this.sharedData = sharedData;

          const currentSiteId = this.sharedData?.selectedSite?.siteId;
          this.siteId = String(currentSiteId);
          this.commonAccessControl =
            sharedData.selectedSite.commonAccessControl;
          this.getUserInfo();
          this.getPhysicalCredential();
        });
    });

    this.route.paramMap?.subscribe((paramMap) => {
      if (paramMap.get('userGroupId')) {
        const userGroupId = Utility.decodeFromBase64(
          paramMap.get('userGroupId') || ''
        );
        this.commonService.setUserGroupId(userGroupId);
      }
    });
  }

  /**
   * @description getPhysicalCredential function will call the getUserCardsList API
   * @returns void
   */
  getPhysicalCredential(): void {
    this.accountSettingService
      .getUserCardsList(this.userId, this.siteId)
      .subscribe({
        next: (res: any) => {
          if (res) {
            this.userCredentials = res;
            this.userCredentials.filter((card: any) => {
              if (card.cardStatus == ACTIVE) {
                this.isUserCardActive = true;
              }
            });
          } else {
            this.isUserCardActive = false;
          }
        },
        error: (err: Error) => {
          this.isUserCardActive = false;
        },
      });
  }

  private getUserInfo() {
    this.accountSettingService
      .getSpecficUserProfileInfo(this.siteId, this.userId)
      .subscribe({
        next: (userProfile: IUserProfile) => {
          this.profileDetails = userProfile;
          this.helperService
            .validatePhoneFormat(this.profileDetails?.phoneNumber)
            .subscribe(
              ({
                phoneNumber,
                region,
                code,
              }: {
                phoneNumber: string;
                region: string;
                code: string;
              }) => {
                this.profileDetails.phoneNumber =
                  code + this.phoneNumberFormat.transform(phoneNumber, code);
                // setting username property
                this.profileDetails.name = `${this.profileDetails?.firstName} ${this.profileDetails.lastName}`;
              },
              (err: string) => {
                if (window.__dev__) console.log('validatePhoneFormat', err);
                this.notificationService?.showError(err);
                this.profileDetails.phoneNumber = '';
              }
            );

          this.tabActiveInActive(this.profileDetails);
          if (
            this.profileDetails?.userType ===
              CONSTANTS.PROPERTY_MANAGER_ADMIN ||
            this.profileDetails?.userType === CONSTANTS.PROPERTY_MANAGER_USER
          ) {
            this.textDescription = this.commonService.stringInterPolation(
              this.translate.instant('ALL_SITE_ACCESS'),
              this.profileDetails?.userType
            );
            this.allAccess = true;
            this.disabledHomeAccess = true;
            this.disabledOtherAccess = true;
            this.disabledTemporaryAccess = true;
          } else {
            this.allAccess = false;

            this.userGroups = this.profileDetails.userGroups!.toString();
            this.lockCount = this.profileDetails.deviceCount || 0;
            this.accessPointCounts = this.profileDetails.accessPointCount || 0;
          }
        },
        error: (err: Error) => {
          this.notificationService.showError(
            this.translate.instant('NO_DETAILS_AVAILABLE_FOR_THIS_USER')
          );
          this.router.navigate([
            `/dashboard/users/${Utility.encodeToBase64(
              this.groupName
            )}/${Utility.encodeToBase64(this.groupTypeId)}}`,
          ]);
        },
      });
  }

  private expiryCheckWithCurrentUTC(
    accessDetail: IAccessDetail[]
  ): IAccessDetail[] {
    return accessDetail?.filter(
      (access) => access.isExpired === false || access.isExpired === null
    );
  }

  private tabActiveInActive(profileDetails: IUserProfile) {
    this.getNotExpiredTempRecords = this.expiryCheckWithCurrentUTC(
      profileDetails?.userAccess?.temporaryAccess
    );

    this.activeTab = CONSTANTS.HOME_ACCESS;

    if (profileDetails?.userAccess?.otherAccess?.length > 0) {
      this.disabledOtherAccess = false;
      this.activeTab = CONSTANTS.ANOTHER_ACCESS;
    } else {
      this.disabledOtherAccess = true;
    }

    if (this.getNotExpiredTempRecords.length > 0) {
      profileDetails.userAccess.temporaryAccess = this.getNotExpiredTempRecords;
      this.disabledTemporaryAccess = false;
      this.activeTab = CONSTANTS.TEMPORARY_ACCESS;
    } else {
      this.disabledTemporaryAccess = true;
    }

    if (profileDetails?.userAccess?.homeAccess?.length > 0) {
      this.disabledHomeAccess = false;
      this.activeTab = CONSTANTS.HOME_ACCESS;
    } else {
      this.disabledHomeAccess = true;
    }

    if (
      profileDetails?.userAccess?.homeAccess?.length < 1 &&
      profileDetails?.userAccess?.otherAccess?.length < 1 &&
      profileDetails?.userAccess?.temporaryAccess?.length < 1
    ) {
      this.activeTab = 'homeAccess';
    }
  }

  /**
   * @description this method is called when delete user button is clicked.
   */
  removeUser() {
    const dialogInstance = this.helperService.openModalDialog(
      ConfirmRemoveDialogComponent,
      {
        title: this.translate.instant('REMOVE_USER'),
        bodyText: this.translate.instant(
          'ARE_YOU_SURE_YOU_WANT_TO_REMOVE_USER'
        ),
        footerText: this.translate.instant(
          'BY_MOVING_FORWARD_YOU_WILL_LOSE_ALL_INFO_USER'
        ),
      },
      CONSTANTS.FIXED_SCREEN_MODAL
    );
    dialogInstance.afterClosed().subscribe((result: boolean) => {
      if (result) {
        // this.groupTypeId

        this.accountSettingService
          .deleteGroup([this.groupTypeId], this.userId)
          .subscribe({
            next: (res: any) => {
              this.notificationService.showSuccess(
                this.commonService.stringInterPolation(
                  this.translate.instant('SUCCESSFULLY_DELETED'),
                  this.translate.instant('USER')
                )
              );

              this.siteId = String(this.siteId);
              const criteria: ICriteria = {
                size: 10000,
                searchText: '',
                userGroupId: this.groupTypeId,
              };
              this.userListsubscription = this.userManagementService
                .getDashboardUsers(criteria)
                .subscribe(() => {
                  this.router.navigate([
                    '/dashboard/users',
                    Utility.encodeToBase64(this.groupName),
                    Utility.encodeToBase64(this.groupTypeId),
                  ]);
                  this.dialogRef?.close();
                });
            },
            error: (err: Error) => {
              if (window.__dev__) console.log('delete user group', err);
              this.notificationService.showError(err?.message);
            },
          });
      }
    });
  }

  homeAccessOnClick(id: string) {
    if (window.__dev__) console.log('homeAccessOnClick', id);
  }

  /**
   * @description: this function is to redirect user profile view modal.
   * @returns void
   */
  viewProfile(): void {
    const dialogInstance = this.helperService.openModalDialog(
      UserProfileComponent,
      {
        enableBackOperation: false,
        defaultNavigation: CONSTANTS.BUILDING,
        profileDetails: this.profileDetails,
        ownProfile: false,
        userId: this.userId,
        parentRouteParams: this.route.snapshot.params,
        siteTimeZone: this.sharedData?.selectedSite?.siteTimeZone,
      },
      [CONSTANTS.FIXED_SCREEN_MODAL, CONSTANTS.SPACE_ZERO]
    );
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    this.apiSubscription?.unsubscribe();
    this.sharedDataSubscription?.unsubscribe();
    this.userListsubscription?.unsubscribe();
  }
}
